import { DefaultState } from 'store/types';

export const LOCATION_MATCHES_FOR_MASS_BOOKING_REQUEST = 'LOCATION_MATCHES_FOR_MASS_BOOKING_REQUEST';
export const LOCATION_MATCHES_FOR_MASS_BOOKING_SUCCESS = 'LOCATION_MATCHES_FOR_MASS_BOOKING_SUCCESS';
export const LOCATION_MATCHES_FOR_MASS_BOOKING_FAILURE = 'LOCATION_MATCHES_FOR_MASS_BOOKING_FAILURE';

export interface LocationMatchesForMassBookingRow {
  id: string;
  name: string;
  lodgingType: string;
  address: string;
  distance: number;
  minRate: number;
  maxRate: number;
  isAnyReservations: boolean;
  likesCount: number;
  notesCount: number;
}

export type LocationMatchesForMassBookingState = DefaultState & {
  contents?: LocationMatchesForMassBookingRow[];
}

interface LocationMatchesForMassBookingRequest {
  type: typeof LOCATION_MATCHES_FOR_MASS_BOOKING_REQUEST;
}

interface LocationMatchesForMassBookingSuccess {
  type: typeof LOCATION_MATCHES_FOR_MASS_BOOKING_SUCCESS;
  contents: LocationMatchesForMassBookingRow[];
}

interface LocationMatchesForMassBookingFailure {
  type: typeof LOCATION_MATCHES_FOR_MASS_BOOKING_FAILURE;
}

export type LocationMatchesForMassBookingActionTypes = LocationMatchesForMassBookingRequest | LocationMatchesForMassBookingSuccess | LocationMatchesForMassBookingFailure;
